<template>
    <div class="custom-picker-inline">
        <div class="picker-content" ref="pickerContent">
            <div class="header">Filter</div>
            <div class="search-wrapper">
                <a-input-search v-model:value="search" placeholder="search item" />
            </div>

            <div class="groups">
                <div class="group-title">
                    {{ title }}
                </div>
                <div class="list-item" v-for="item in getFilteredItems()" @click="(e) => change(e, item)">
                    <a-checkbox
                        class="segment-checkbox"
                        @click="(e) => change(e, item)"
                        :checked="isSelected(item)"
                        v-if="multiple"
                    />
                    <a-radio
                        class="segment-checkbox"
                        @click="(e) => change(e, item)"
                        :checked="isSelected(item)"
                        v-else
                    />
                    <div class="metas">
                        <span>{{ item[labelKey] }}</span>
                        <small v-if="item.description">{{ item.description }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import log2 from "../../utils/log2";

const log = log2("CustomPickerInline");
export default Vue.extend({
    name: "CustomPickerInline",
    components: {
        SupsisButton,
    },
    props: {
        value: {
            type: String | Object | Number | Array,
        },
        items: {
            //string or array
            type: Array,
            default: () => [],
        },
        idKey: {
            type: String,
            required: true,
        },
        labelKey: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: "Select item",
        },
        icon: {
            type: String,
            default: "filter_list",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            search: "",
            clone: _.cloneDeep(this.value),
            visible: false,
            cancels: [],
        };
    },
    computed: {
        ...mapState({}),
        ...mapGetters({}),
    },
    methods: {
        change(e, item) {
            e.stopPropagation();

            if (this.multiple) {
                this.clone = Array.isArray(this.clone) ? this.clone : [];
                if (this.isSelected(item)) {
                    this.clone = this.clone.filter((x) => x !== item[this.idKey]);
                } else {
                    this.clone = [...this.clone, item[this.idKey]];
                }
            } else {
                if (this.clone === item[this.idKey]) {
                    this.clone = null;
                } else {
                    this.clone = item[this.idKey];
                }
            }
        },
        getFilteredItems() {
            const q = (this.search || "").trim().toLowerCase();

            return this.items.filter((item) => (item[this.labelKey] || "").toLowerCase().includes(q));
        },
        isSelected(item) {
            log("isSelected", item);
            if (this.multiple) {
                return (this.clone || []).includes(item[this.idKey]);
            } else {
                return this.clone === item[this.idKey];
            }
        },
    },
    mounted() {
        this.cancels.push(() => {});
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    this.clone = _.cloneDeep(val);
                }
            },
        },
        clone: {
            deep: true,
            handler(val) {
                const isChanged = !_.isEqual(val, this.value);
                if (isChanged) {
                    log("emit", val);
                    this.$emit("input", val);
                }
            },
        },
    },
});
</script>

<style lang="scss">
.custom-picker-inline {
    display: flex;
    flex-direction: column;

    .picker-content {
        display: flex;
        flex-direction: column;
        gap: 3px;
        width: 300px;

        .btnGroup {
            display: flex;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
            margin: 2px 10px;
            padding: 2px;

            .btnGrupItem {
                &.selected {
                    background: var(--color-bg-oncomponent-default);
                    box-shadow: var(--shadow-interaction-200);
                }
            }

            .supsis-button {
                border: none !important;
                font-size: 13px;
                height: 25px;
            }
        }

        .header {
            display: flex;
            flex-flow: column;
            color: var(--color-text-strong-default);
            background-color: var(--color-bg-neutral-low-default);
            outline-style: none;
            cursor: default;
            justify-content: center;
            align-items: center;
            padding: 8px;
            width: 100%;
        }

        .search-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px 20px;
        }

        .groups {
            display: flex;
            flex-direction: column;
            max-height: 600px;
            min-height: 300px;
            overflow-y: auto;
        }

        .group-title {
            display: flex;
            flex-flow: column;
            color: var(--color-text-strong-default);
            background-color: var(--color-bg-neutral-low-default);
            outline-style: none;
            cursor: default;

            font-weight: 600;
            justify-content: left;
            text-align: left;
            text-transform: uppercase;
            padding: 8px 12px;
            font-size: 12px;
        }

        .list-item {
            position: relative;
            padding: 8px 12px;
            cursor: pointer;
            transition: background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
            overflow-wrap: anywhere;
            background-color: var(--color-bg-default);
            font-size: 14px;
            font-weight: 500;
            color: var(--color-text-strong-default);
            align-items: flex-start;
            border-bottom: 1px solid var(--color-border-default);
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 5px;
            .metas {
                display: flex;
                flex-direction: column;
            }

            small {
                font-size: 10px;
                color: var(--color-text-weak-default);
            }

            &:hover {
                background: var(--color-bg-hover);
            }
        }
    }
}
</style>
